// import React from 'react';
import React, { Component } from "react";
import Router from "./markup/router";
import WhatsAppWidget from "./markup/element/WhatsAppWidget";
import "./App.css";

import "./plugins/fontawesome/css/font-awesome.min.css";
import "./plugins/line-awesome/css/line-awesome.min.css";
import "./plugins/flaticon/flaticon.css";
import "./plugins/flaticon/beer/flaticon.css";
// import './css/plugins.css';
// import './css/style.css';

// import './css/templete.min.css';

import "@fortawesome/fontawesome-free/css/all.min.css";
import ScrollToTop from "./markup/element/scrollToTop";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router />
        <WhatsAppWidget />
        <ScrollToTop className="icon-up" />
      </div>
    );
  }
}

export default App;
